<template>
    <Form :rules="innerRules" inline populateType="chain" :value="list">
        <template>
            <field-group
                v-for="(item, index) in list"
                :key="index"
                :model="item"
                class="rent-item"
            >
                <FormItem class="rent-field" prop="startPeriod">
                    <Select
                        v-model="item.startPeriod"
                        transfer
                        placeholder="请选择开始账期"
                        style="width: 230px"
                    >
                        <Option
                            v-for="p in periodList"
                            :value="p.period"
                            :key="p.period"
                            :disabled="
                                index > 0 &&
                                p.period <= list[index - 1].endPeriod
                            "
                        >
                            第{{ p.period }}期 ({{ p.startDate }} 至
                            {{ p.endDate }})
                        </Option>
                    </Select>
                </FormItem>
                <FormItem class="rent-field" prop="endPeriod">
                    <Select
                        v-model="item.endPeriod"
                        transfer
                        placeholder="请选择结束账期"
                        style="width: 230px"
                    >
                        <Option
                            v-for="p in periodList"
                            :value="p.period"
                            :key="p.period"
                            :disabled="p.period <= list[index].startPeriod"
                        >
                            第{{ p.period }}期 ({{ p.startDate }} 至
                            {{ p.endDate }})
                        </Option>
                    </Select>
                </FormItem>
                <!-- 涨幅计算类型 -->
                <FormItem class="rent-field" prop="increaseWay">
                    <Select
                        v-model="item.increaseWay"
                        transfer
                        style="width: 100px"
                    >
                        <Option
                            v-for="v in increaseWayList"
                            :value="v.id"
                            :key="v.id"
                        >
                            {{ v.text }}
                        </Option>
                    </Select>
                </FormItem>
                <!-- 涨幅值 -->
                <FormItem class="rent-field" prop="numerical">
                    <input-number
                        v-model="item.numerical"
                        :min="0"
                        :allowNegative="false"
                        style="width: 100px"
                    >
                        <template #append>
                            {{
                                item.increaseWay == enums.increaseWay.Percent
                                    ? '%'
                                    : '元'
                            }}
                        </template>
                    </input-number>
                </FormItem>

                <span v-if="finalEditable" class="rent-cut" @click="cut(index)">
                    -
                </span>
            </field-group>
        </template>
        <div
            v-if="
                finalEditable && $can('increase', 'api/contract/info?type=zz')
            "
            style="line-height: 30px"
        >
            <div class="rent-add" @click="add">
                <span class="rent-add-plus">+</span>添加涨幅
            </div>
        </div>
    </Form>
</template>
<script>
// 优惠费用
import { Field } from 'ivux'
import { ymd } from '_u/helper'
import { getPeriods } from '@/api/contract'

export default {
    name: 'RentIncreasePeriod',

    mixins: [Field],

    props: {
        value: {
            type: Array,
            default: () => [],
        },

        populateType: {
            type: String,
            default: 'through',
        },
        // 约定租期开始日期
        startDate: {
            type: [String, Date],
            default: '',
        },
        // 预订租期结束日期
        endDate: {
            type: [String, Date],
            default: '',
        },
        // 交租方式(租金)
        rentPayMethod: {
            type: [String, Number],
            default: '',
        },
        // 账期合并列表
        mergeList: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            inited: false,
            list: this.value,
            enums: {
                increaseWay: this.$enum.get('increaseWay'),
            },
            periodList: [], // 账期列表
        }
    },

    watch: {
        value(val) {
            this.setData(val)
        },

        list: {
            handler(val) {
                this.$emit('input', val)
            },
            deep: true,
        },
    },

    computed: {
        innerRules() {
            var rules = {
                startPeriod: [{ required: true, message: '开始账期必填' }],
                endPeriod: [{ required: true, message: '结束账期必填' }],
                amount: [{ required: true, message: '优惠金额必填' }],
            }
            return rules
        },
        increaseWayList() {
            return this.enums.increaseWay.toList()
        },
    },

    created() {
        // this.fetch()

        // 联动查询合同账期
        this.$watch(
            function () {
                return (
                    '' +
                    this.startDate +
                    this.endDate +
                    this.rentPayMethod +
                    this.mergeList
                )
            },
            function (val) {
                if (
                    !!this.startDate &&
                    !!this.endDate &&
                    !!this.rentPayMethod
                ) {
                    this.fetchPeriods()
                }
            },
            {
                immediate: true,
            }
        )
    },

    methods: {
        // 获取账期
        fetchPeriods() {
            return getPeriods({
                startDate: ymd(this.startDate),
                endDate: ymd(this.endDate),
                rentPayMethod: this.rentPayMethod,
                mergeList: this.mergeList,
            }).then((res) => {
                this.periodList = res.data.periodList
            })
        },
        createItem() {
            return {
                startPeriod: '', // 开始账期
                endPeriod: '', // 开始账期
                increaseWay: this.enums.increaseWay.Percent, // 涨幅方式
                numerical: 0, // 涨幅值
            }
        },

        setData(list) {
            this.list = [...list]
        },

        add() {
            this.list.push(this.createItem())
        },

        cut(i) {
            this.list.splice(i, 1)
        },
    },
}
</script>
<style lang="less" scoped>
.rent {
    &-item {
        display: flex;
        margin-bottom: 18px;
    }

    &-field {
        flex-basis: 20px;
    }

    &-text {
        margin-right: 10px;
    }

    &-cut {
        display: inline-block;
        cursor: pointer;
        line-height: 0;
        font-size: 18px;
        padding: 14px 10px;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fff;
    }

    &-add {
        display: inline-block;
        cursor: pointer;
        line-height: 14px;

        &-plus {
            line-height: 12px;
            padding: 0 2px;
            margin-right: 2px;
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 4px;
            background: #fff;
        }
    }
}
</style>
